export function stripMetaTags(html)
{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Remove all <meta> tags from <head>
    const metaTags = doc.head.querySelectorAll("meta");
    metaTags.forEach(tag => tag.remove());

    return doc.body.innerHTML;
}